import styled from '@emotion/styled';
import { Header } from 'components';
import { mobileHeaderSize } from 'layouts/MobileLayout/MobileHeader/MobileHeader.style';

export const CartContentContainer = styled.div`
    padding: ${({ theme }) => theme.base.spacing[4]};
    padding-top: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const CarContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const ProductSummaryContainer = styled.div`
    margin-bottom: ${({ theme }) => theme.base.spacing[8]};
`;

export const MargedHeader = styled(Header)`
    padding: ${({ theme }) => theme.base.spacing[4]};
    top: ${mobileHeaderSize};
    padding-bottom: 0;
    position: sticky;
`;

export const BottomBar = styled.div`
    padding: ${({ theme }) => theme.base.spacing[4]};
    background: ${({ theme }) => theme.base.color.backgroundMain};
    position: sticky;
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
`;
